"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/input-number/style");
var _inputNumber = _interopRequireDefault(require("antd/lib/input-number"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/select/style");
var _select = _interopRequireDefault(require("antd/lib/select"));
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ImageUploader = _interopRequireWildcard(require("../../ImageUploader"));
var _utils = require("../../../utils");
var _async = _interopRequireDefault(require("react-select/async"));
var _DropdownIndicator = require("../../SearchableReactSelect/components/DropdownIndicator");
var _api = require("../api");
var _constants = require("../constants");
var _Toggle = require("../../../components/Toggle");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Option = _select.default.Option;
var useSelectSearch = function useSelectSearch(data) {
  var _useState = (0, _react.useState)(data),
    _useState2 = _slicedToArray(_useState, 2),
    filteredData = _useState2[0],
    setFilteredData = _useState2[1];
  (0, _react.useEffect)(function () {
    setFilteredData(data);
  }, [data]);
  var onSearch = (0, _react.useCallback)(function (value) {
    var filtered = value ? data.filter(function (e) {
      var _e$name;
      return e === null || e === void 0 ? void 0 : (_e$name = e.name) === null || _e$name === void 0 ? void 0 : _e$name.toLowerCase().includes(value.toLowerCase());
    }) : data;
    setFilteredData(filtered);
  }, [data]);
  return {
    filteredData: filteredData,
    onSearch: onSearch
  };
};
var imageValidators = [(0, _ImageUploader.maxImageSizeValidator)(20, 'Please choose an image with size less than 20Mb'), (0, _ImageUploader.isAllowedTypeValidator)(_utils.ACCEPT_IMAGE_TYPES, function (file, fileType) {
  return (0, _ImageUploader.composeAcceptedFileTypesText)(_utils.ACCEPT_IMAGE_TYPES, fileType);
})];
var AddGroupForm = function AddGroupForm(_ref) {
  var clinicians = _ref.clinicians,
    form = _ref.form,
    loadingClinicians = _ref.loadingClinicians,
    onSubmit = _ref.onSubmit,
    processing = _ref.processing;
  var getFieldDecorator = form.getFieldDecorator,
    getFieldValue = form.getFieldValue;
  var _useSelectSearch = useSelectSearch(clinicians),
    filteredData = _useSelectSearch.filteredData,
    onSearch = _useSelectSearch.onSearch;
  var ownerId = getFieldValue('clinicianId');
  var _useClinicianAndPatie = (0, _api.useClinicianAndPatientModeratorsSearch)(form, ownerId),
    onLoadClinicianOptions = _useClinicianAndPatie.onLoadClinicianOptions,
    onLoadPatientOptions = _useClinicianAndPatie.onLoadPatientOptions;
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    image = _useState4[0],
    setImage = _useState4[1];
  var validateFieldsAndScroll = form.validateFieldsAndScroll;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    validateFieldsAndScroll(function (err, values) {
      if (!(0, _ImageUploader.validateImage)(image) || err) {
        return;
      }
      var upload = values.upload,
        clinicianModerators = values.clinicianModerators,
        patientModerators = values.patientModerators;
      var clinicianModeratorIds = clinicianModerators === null || clinicianModerators === void 0 ? void 0 : clinicianModerators.map(function (m) {
        return m.value;
      });
      var patientModeratorIds = patientModerators === null || patientModerators === void 0 ? void 0 : patientModerators.map(function (m) {
        return m.value;
      });
      onSubmit(_objectSpread(_objectSpread({}, values), {}, {
        upload: upload[0],
        clinicianModeratorIds: clinicianModeratorIds,
        patientModeratorIds: patientModeratorIds
      }));
    });
  };
  var fieldsError = form.getFieldsError();
  var validationErrors = (0, _react.useMemo)(function () {
    return (0, _lodash.chain)(fieldsError).values().compact().some(function (e) {
      return e;
    }).value();
  }, [fieldsError]);

  // put moderator names in alphabetical order
  filteredData.sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
  var isWebinarChecked = !!getFieldValue('isWebinar');
  var filterModeratorOptions = function filterModeratorOptions(option) {
    return option ? option.data.value !== ownerId : false;
  };
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: processing,
    size: "large"
  }, /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit,
    className: "AddGroupForm",
    size: "large",
    hideRequiredMark: true
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Name"
  }, getFieldDecorator('name', {
    rules: [{
      required: true,
      message: 'Please enter group name',
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    placeholder: "Enter group name",
    size: "large"
  }))), clinicians && /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Owner"
  }, getFieldDecorator('clinicianId', {
    rules: [{
      required: true,
      message: 'Please select a moderator'
    }]
  })( /*#__PURE__*/_react.default.createElement(_select.default, {
    onSearch: onSearch,
    showSearch: true,
    size: "large",
    filterOption: false,
    suffixIcon: loadingClinicians && /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: "loading"
    }),
    placeholder: "Select main moderator"
  }, filteredData.map(function (clinician) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      value: clinician.value,
      key: clinician.value
    }, clinician.name);
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Group type"
  }, getFieldDecorator('type', {
    initialValue: _utils.GroupTypes.Public,
    rules: [{
      required: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_select.default, {
    showSearch: false,
    size: "large",
    filterOption: false,
    placeholder: "Select group type"
  }, Object.values(_utils.GroupTypes).map(function (type) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      value: type,
      key: type
    }, type);
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Group is a webinar"
  }, getFieldDecorator('isWebinar', {
    initialValue: false,
    rules: [{
      required: false
    }]
  })( /*#__PURE__*/_react.default.createElement(_Toggle.Toggle, null))), isWebinarChecked && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Select more clinician moderators"
  }, getFieldDecorator(_constants.CLINICIAN_MODERATORS_FIELD_NAME, {
    initialValue: undefined,
    rules: [{
      required: false
    }]
  })( /*#__PURE__*/_react.default.createElement(_async.default, {
    className: "searchable-react-select mb-[24px] mt-0",
    classNamePrefix: "searchable-select-inner",
    placeholder: "Search clinician moderators...",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: _DropdownIndicator.DropdownIndicator
    },
    filterOption: filterModeratorOptions,
    loadOptions: onLoadClinicianOptions,
    isClearable: false,
    isMulti: true
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Select more patient moderators"
  }, getFieldDecorator(_constants.PATIENT_MODERATORS_FIELD_NAME, {
    initialValue: undefined,
    rules: [{
      required: false
    }]
  })( /*#__PURE__*/_react.default.createElement(_async.default, {
    className: "searchable-react-select mb-[24px] mt-0",
    classNamePrefix: "searchable-select-inner",
    placeholder: "Search patient moderators...",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: _DropdownIndicator.DropdownIndicator
    },
    filterOption: filterModeratorOptions,
    loadOptions: onLoadPatientOptions,
    isClearable: false,
    isMulti: true
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Description"
  }, getFieldDecorator('description', {
    rules: [{
      required: true,
      message: 'Please enter description',
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default.TextArea, {
    placeholder: "Enter description",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Welcome message"
  }, getFieldDecorator('welcomeMessage', {
    rules: [{
      required: true,
      message: 'Please enter welcome message',
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default.TextArea, {
    placeholder: "Enter moderator\u2019s welcome message",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "How it works"
  }, getFieldDecorator('howItWorks', {
    rules: [{
      required: false,
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default.TextArea, {
    placeholder: "Enter how it works text",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Resources"
  }, getFieldDecorator('resources', {
    rules: [{
      required: false,
      whitespace: true
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default.TextArea, {
    placeholder: "Enter resources text",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Group introduction video URL"
  }, getFieldDecorator('videoUrl', {
    rules: [{
      required: false,
      whitespace: true
    }, {
      validator: (0, _utils.urlValidator)()
    }]
  })( /*#__PURE__*/_react.default.createElement(_input.default, {
    placeholder: "Group introduction video URL",
    size: "large"
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Group image"
  }, getFieldDecorator('upload', {
    valuePropName: 'fileList',
    rules: [{
      required: true,
      message: 'Please attach a group image'
    }]
  })( /*#__PURE__*/_react.default.createElement(_ImageUploader.default, {
    placeholderText: "Upload group image (max 20 Mb )",
    validators: imageValidators,
    onDecodeImage: setImage
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "RSVP Capacity"
  }, getFieldDecorator('capacity', {
    first: true,
    initialValue: 50,
    rules: [{
      required: true,
      message: 'Please enter the group’s rsvp capacity'
    }]
  })( /*#__PURE__*/_react.default.createElement(_inputNumber.default, {
    min: 1,
    max: _utils.MAX_DAILYCO_GROUP_SESSION_CAPACITY
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    htmlType: "submit",
    size: "large",
    block: true,
    disabled: validationErrors,
    loading: processing
  }, "Create group"))));
};
AddGroupForm.propTypes = {
  clinicians: _propTypes.default.array,
  onSubmit: _propTypes.default.func,
  loadingClinicians: _propTypes.default.bool,
  processing: _propTypes.default.bool
};
var _default = _form.default.create({
  name: 'AddGroup'
})(AddGroupForm);
exports.default = _default;